import { AddTourTravelParams } from '@/domain/project-tour-ontour/actions/add-tour-travel.action';
import {
  TourTravel,
  TourTravelConnexionTypeWithEvent,
  TourTravelConnexionTypeWithEventValues,
} from '@/domain/project-tour-ontour/entities/project-tour-ontour-travel.entity';
import { validateValueInType } from '@/domain/utils/validate-value-in-type';

import { PositionDto } from '../position-geocode/position.dto.schema';
import { PositionMapper } from '../position-geocode/position.mapper';
import { TourTravelDto } from './project-tour-travel.dto.schema';

type AddTourTravelDto = {
  organisationId: number;
  sequenceId: number;
  name: string;
  connexionTypeWithEvent: string;
  travelDistance: number;
  fromEventId: number | undefined;
  fromPosition: PositionDto | undefined;
  toEventId: number | undefined;
  toPosition: PositionDto | undefined;
};

type EditTourTravelDto = {
  name: string;
  connexionTypeWithEvent: string;
  travelDistance: number;
  fromEventId: number | undefined;
  fromPosition: PositionDto | undefined;
  toEventId: number | undefined;
  toPosition: PositionDto | undefined;
};

export class TourTravelMapper {
  static dtoToEntity(dto: TourTravelDto): TourTravel {
    return {
      id: dto.id,
      sequenceId: Number.parseInt(dto.sequenceId.toString()),
      name: dto.name,
      connexionTypeWithEvent:
        validateValueInType<TourTravelConnexionTypeWithEvent>(
          dto.connexionTypeWithEvent,
          TourTravelConnexionTypeWithEventValues,
        ),
      travelDistance: dto.travelDistance,
      fromEventId: dto.fromEventId
        ? Number.parseInt(dto.fromEventId.toString())
        : undefined,
      fromPosition: dto.fromPosition
        ? PositionMapper.dtoToEntity(dto.fromPosition)
        : undefined,
      toEventId: dto.toEventId
        ? Number.parseInt(dto.toEventId.toString())
        : undefined,
      toPosition: dto.toPosition
        ? PositionMapper.dtoToEntity(dto.toPosition)
        : undefined,
    };
  }

  static prepareAddTravelDto(
    organisationId: number,
    sequenceId: number,
    tourTravel: AddTourTravelParams['tourTravel'],
  ): AddTourTravelDto {
    return {
      organisationId: organisationId,
      sequenceId: sequenceId,
      name: tourTravel.name,
      travelDistance: tourTravel.travelDistance,
      connexionTypeWithEvent: tourTravel.connexionTypeWithEvent,
      fromEventId: tourTravel.fromEventId,
      fromPosition: tourTravel.fromPosition
        ? PositionMapper.entityToDto(tourTravel.fromPosition)
        : undefined,
      toEventId: tourTravel.toEventId,
      toPosition: tourTravel.toPosition
        ? PositionMapper.entityToDto(tourTravel.toPosition)
        : undefined,
    };
  }

  static prepareEditTravelDto(tourTravel: TourTravel): EditTourTravelDto {
    return {
      name: tourTravel.name,
      travelDistance: tourTravel.travelDistance,
      connexionTypeWithEvent: tourTravel.connexionTypeWithEvent,
      fromEventId: tourTravel.fromEventId,
      fromPosition: tourTravel.fromPosition
        ? PositionMapper.entityToDto(tourTravel.fromPosition)
        : undefined,
      toEventId: tourTravel.toEventId,
      toPosition: tourTravel.toPosition
        ? PositionMapper.entityToDto(tourTravel.toPosition)
        : undefined,
    };
  }
}
